<lx-card-container
  [loading]="loading()"
  skeletonHeight="22rem"
  i18n-title
  type="accommodation"
  title="Your accommodation"
  [attr.data-qa]="'accommodationType_header'"
>
  <lx-option-card
    *ngFor="let accommodation of accommodations"
    [type]="'radio'"
    [title]="accommodation?.title"
    [image]="accommodation?.image"
    [option]="accommodation?.code"
    [selectedOption]="selectedAccommodation?.code"
    [attr.data-qa]="'accommodationType_card-' + accommodation.code"
    (selectedOptionChanged)="setSelectedAccommodation(accommodation)"
    >{{ accommodation?.description }}
  </lx-option-card>
  <lx-option-card
    *ngIf="optional"
    title="I don't need accommodation"
    i18n-title
    [withImage]="false"
    [type]="'radio'"
    [selectedOption]="selectedAccommodation?.code"
    (selectedOptionChanged)="setSelectedAccommodation(null)"
    [attr.data-qa]="'accommodationType_noAccommodation_button'"
  ></lx-option-card>
</lx-card-container>
